// Send cadence maps directly onto the period and period_type columns on EmailCampaign.
// Shared by the create modal and the campaign editor so the two cannot drift apart.

const c_PeriodTypeOptions = [
	{ value: 'minutes', label: 'Minutes' },
	{ value: 'hours', label: 'Hours' },
	{ value: 'days', label: 'Days' }
];

const c_DefaultPeriod = '3';
const c_DefaultPeriodType = 'days';

// Formats a date for an <input type="date">, which only accepts YYYY-MM-DD
const to_date_input_value = (value) => {
	if(!value) {
		return '';
	}

	const date = new Date(value);
	if(isNaN(date.getTime())) {
		return '';
	}

	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	return date.getFullYear() + '-' + month + '-' + day;
};

// The campaign ends after the last email goes out, so the span is one period short of the
// email count: three emails every 3 days starting the 1st finishes on the 7th, not the 10th.
const calculate_end_date = (start_date, period, period_type, total_emails) => {
	if(!start_date) {
		return '';
	}

	const start = new Date(start_date);
	if(isNaN(start.getTime())) {
		return '';
	}

	const period_value = parseInt(period, 10);
	const email_count = parseInt(total_emails, 10);

	if(!period_value || !email_count || period_value < 1 || email_count < 1) {
		return '';
	}

	const gaps = email_count - 1;
	const end = new Date(start.getTime());

	if(period_type === 'minutes') {
		end.setMinutes(end.getMinutes() + (period_value * gaps));
	}
	else if(period_type === 'hours') {
		end.setHours(end.getHours() + (period_value * gaps));
	}
	else {
		end.setDate(end.getDate() + (period_value * gaps));
	}

	return end;
};

export {
	c_PeriodTypeOptions,
	c_DefaultPeriod,
	c_DefaultPeriodType,
	to_date_input_value,
	calculate_end_date
};
